<!--LOADING-->
<ng-template [ngIf]="isLoading">
  <app-loading-page class="white-top-theme"></app-loading-page>
</ng-template>
<!--END LOADING-->
<!--POINTILLIST DETAIL-->
<ng-template [ngIf]="!isLoading">
  <ng-container *ngIf="contentData">
    <ng-container *ngIf="showPointillistDetailHeroBanner; else showCMSOnly">
      <section class="pointillist">
        <!--POINTILLIST CONTENT START-->
        <app-hero-banner
          *ngIf="showPointillistCMSContent"
          [heroImageCss]="'announcement-hero'"
          [id]="'pointillist-detail'"
          [displayCss]="['flexbox', 'flexwrap', 'flex-direction-row-reverse']"
          [alignContentCss]="['hero-wrapper-left', 'margin-left-auto']"
          [showButton]="false">
          <!--NOTE: Inject custom content-->
          <!--NOTE: content is being binded by 'subHeader' in hero banner-->
          <div subHeader>
            <img src="/assets/img/pointillist-logo.svg" />
            <!--CMS CONTENT-->
            <!--NOTE ngIf used to populate WordPress content-->
            <div class="margin-left-x-large">
              <app-static-page
                [bodyContent]="contentData?.content | safe : 'html'"></app-static-page>
            </div>
            <!--END CMS CONTENT-->
          </div>
          <div content>
            <img
              src="/assets/img/Pointillist-graphic.png"
              alt="Pointillist image"
              height="389px"
              width="400px" />
          </div>
        </app-hero-banner>
        <!--POINTILLIST CONTENT END-->
      </section>
    </ng-container>
  </ng-container>
</ng-template>
<!--END POINTILLIST DETAIL-->

<ng-template #showCMSOnly>
  <div class="wrapper">
    <app-static-page [bodyContent]="contentData?.content | safe : 'html'"></app-static-page>
  </div>
</ng-template>
